module.exports = __webpack_public_path__ + "img/close.215c066f.svg";